import { isEmpty } from 'lodash';
import { type IConditionGroupExpression } from '../../../schema/expressions/repository/condition-group/IConditionGroupExpression.ts';

export type IBooleanCondition =
  | null
  | IBooleanStaticCondition
  | IBooleanExpressionCondition;

export interface IBooleanStaticCondition {
  type: 'static';
  value: boolean;
}

export function createBooleanStaticCondition(
  value: boolean,
): IBooleanStaticCondition {
  return { type: 'static', value };
}

export interface IBooleanExpressionCondition {
  type: 'expression';
  expression: IConditionGroupExpression;
}

/**
 * Controlla se una condizione è statica e attiva (dunque, _sempre_ attiva).
 * **Attenzione!** Una condizione _vuota_ è considerata statica e attiva, per
 * evitare che un widget venga disabilitato o nascosto in caso di errore.
 *
 * @param options assumeValue Valore da assumere se la condizione non è definita,
 *  di default è `true`
 */
export function isStaticActive(
  condition: IBooleanCondition | undefined,
  options: { assumeValue: boolean } = { assumeValue: true },
) {
  if (!condition || isEmpty(condition)) return options.assumeValue;
  return condition?.type === 'static' && condition.value === true;
}
